import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '快速导航',
    links: [
      { label: '首页', href: '/' },
      { label: '服务分类', href: '/category/all' },
      { label: '新闻资讯', href: '/category/news' },
      { label: '关于我们', href: '/about' },
    ],
  },
  {
    title: '服务支持',
    links: [
      { label: '帮助中心', href: '/category/all' },
      { label: '常见问题', href: '/#faq' },
      { label: '安全指南', href: '/category/all' },
      { label: '用户协议', href: '/about' },
    ],
  },
  {
    title: '关于开云',
    links: [
      { label: '品牌介绍', href: '/about' },
      { label: '资质信誉', href: '/about#reputation' },
      { label: '联系我们', href: '/about#contact' },
      { label: '加入我们', href: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-cloud-line text-lg text-white"></i>
              </div>
              <span className="text-xl font-bold font-heading text-white">开云官网</span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed mb-5 max-w-xs">
              开云官网是您访问开云平台的官方正版渠道，提供安全稳定的登录入口与丰富的产品服务。
            </p>
            <div className="flex gap-3">
              <a href="#wechat" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#weibo" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#community" className="w-9 h-9 rounded-lg bg-background-800 flex items-center justify-center text-foreground-300 hover:bg-primary-500 hover:text-white transition-colors duration-200 cursor-pointer">
                <i className="ri-chat-smile-2-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-white mb-4 font-label">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-700/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 开云平台 版权所有 | 粤ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <span>客服热线：400-888-8888</span>
            <span className="hidden sm:inline">|</span>
            <span>邮箱：service@kaiyun.com</span>
          </div>
        </div>
      </div>
    </footer>
  );
}